<script>
export default {
    name: "AdmissionNote",

    data() {

        return {
            patient: {},
            orgs: [],
            admission: {},
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchPatient(), this.fetchAdmissionDetails(), this.fetchPatientOrgs()])
            .then(() => {
                this.$root.loading=false;
                setTimeout(() => {
                    window.print();
                },250);
        }).catch(() => {this.$root.loading=false;});
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchAdmissionDetails() {
            let url = `Admissions/GetAdmissionSheet`;
                url += `?PatientID=${this.$route.params.patientID}`;
                url += `&VisitNo=${this.$route.params.visitNO}`;

            return this.$http.get(url).then(response => {
                this.admission=response.data.length ? response.data[0]: {};
            }).catch(() => {});
        },

        fetchPatientOrgs() {
            let url = `Visits/GetPatientInsuranceforUse`;
                url += `?CustomerID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(response => {
                this.orgs = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
<div class="flex flex-wrap w-full">
    <tail-address-header></tail-address-header>
    <div class="w-full flex flex-wrap px-1 mt-1 border-t border-gray-400">
        <div class="w-full my-2 border-b">
            <h5 class="font-bold text-center">PATIENT ADMISSION NOTE</h5>
        </div>
        <div class="w-1/3 my-1">
            <h5 class="font-semibold">Name: {{ patient.names }}</h5>
        </div>
        <div class="w-1/3 my-1">
            <h5 class="font-semibold">MRN: {{ patient.patienT_ID }}</h5>
        </div>
        <div class="w-1/3 my-1">
            <h5 class="font-semibold">Gender: {{ patient.gender }}</h5>
        </div>
        <div class="w-1/3 my-1">
            <h5 class="font-semibold">IP NO: {{ patient.ipfileno }}</h5>
        </div>
        <div class="w-1/3 my-1">
            <h5 class="font-semibold">Date: {{admission.sysDate | dateFormatDT}}</h5>
        </div>
        <div class="w-1/3 my-1">
            <h5 class="font-semibold">Requested By: {{admission.requestedBy}}</h5>
        </div>
        <div class="w-1/3 my-1">
            <h5 class="font-semibold">Payment: {{ patient.pMode }}</h5>
        </div>
        <div class="w-1/3 my-1">
            <h5 class="font-semibold">Ward Package: {{ admission.type }}</h5>
        </div>
        <div class="w-1/3 my-1">
            <h5 class="font-semibold">Ward: {{ admission.ward }}</h5>
        </div>
        <div class="w-1/3 my-1">
            <h5 class="font-semibold">Bed: {{ admission.bed }}</h5>
        </div>
    </div>
    <table class="table mt-1 text-sm">
        <thead>
            <tr class="border-b-2 border-t-2">
                <th class="p-tiny">Org</th>
                <th class="p-tiny">Prinicipal Dependant</th>
                <th class="p-tiny">Member No</th>
                <th class="p-tiny">Notification No</th>
            </tr>
        </thead>
        <tbody>
            <tr class="border-b" v-for="(org,idx) in orgs" :key="idx">
                <td class="p-tiny">{{ org.organization }}</td>
                <td class="p-tiny">{{ org.principalOfDependant }}</td>
                <td class="p-tiny">{{ org.memberno }}</td>
                <td class="p-tiny">{{ org.notificationNo }}</td>
            </tr>
        </tbody>
    </table>
    <div class="w-full my-1 text-right text-sm">
        <h5 class="font-semibold">Admitted By: {{ patient.username }}</h5>
    </div>
</div>
</template>